import { memo } from "react";
import { useTypedSelector } from "hooks";
import { OnboardingApplicationStatus } from "consts/onboarding";
import { ConfirmatableDialog } from "ui/molecules/Dialog";
import useActions from "features/onboarding/useActions";
import { selectIsApplicationsLoading } from "features/onboarding/selectors";
import useSendApplicationDecision from "features/onboarding/useSendApplicationDecision";
import { Action, useApplicationTableResourceContext } from "../ApplicationTableResourceProvider";

const ApproveManuallyApplication = () => {
    const { context, onClose } = useApplicationTableResourceContext();

    const {
        isLoading,
        sendApplicationDecision
    } = useSendApplicationDecision();

    const isApplicationsLoading = useTypedSelector(selectIsApplicationsLoading);

    const { updateApplication } = useActions();

    const handleCompleteApplication = () => {
        const params = {
            userId: context!.row.userId,
        };

        const [request] = updateApplication({
            ...params,
            status: OnboardingApplicationStatus.Approved
        });

        return request
            .then(() => sendApplicationDecision(params))
            .then(onClose);
    };

    const content = {
        dialogContent: [
            `Are you sure you want to approve the application ${context?.row.pki}?`
        ],
        actionContent: 'Yes'
    };

    return (
        <ConfirmatableDialog
            isProcessing={isLoading || isApplicationsLoading}
            open={Object.is(context?.action, Action.ApproveApplication)}
            checkPredicate={() => false}
            content={[
                content,
                content
            ]}
            onConfirm={handleCompleteApplication}
            onCancel={onClose}
        />
    );
};

export default memo(ApproveManuallyApplication);
